var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0015 18.9538C10.3517 19.055 8.94407 17.813 8.83827 16.1754C8.74014 14.5363 9.97601 13.1195 11.6289 13.0152C13.2619 12.911 14.6665 14.1622 14.7707 15.7998C14.8765 17.4389 13.6361 18.8526 12.0015 18.9538ZM39.4002 14.5394C37.4743 12.5905 34.2911 12.9279 32.4143 14.9166C29.9717 17.4803 28.0719 18.4387 25.8072 18.3436C22.6485 18.2056 21.0891 15.7615 19.4684 12.6795C17.7833 9.46099 15.1904 7.66699 11.9597 7.66699C6.87821 7.66699 3.83301 11.7809 3.83301 16.3687C3.83301 23.4281 8.79641 27.6479 12.2326 29.4265C15.0877 30.9154 18.2632 31.5349 21.0891 31.6069C20.922 33.2936 20.4252 35.5215 19.8778 37.0993H20.1676H22.8049H25.4392H25.6891C25.1172 35.5215 24.6097 33.1096 24.4533 31.4183C32.9679 30.3128 37.0128 26.4473 39.2269 22.7657C40.2205 21.1496 40.7511 19.4721 40.7449 17.9649C40.7373 16.6447 40.3171 15.4441 39.4002 14.5394Z",
    fill: "#6EB329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/교보증권-46.9d4acbf30a58425fb52ff28d10af50c0.svg";
export { ForwardRef as ReactComponent };